import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLatestStatus } from 'utils/formatters/shipments';
import { getShipmentDetailUrl } from '../../../../utils/formatters/shipments';

export default class DriverJobRow extends Component {
  static propTypes = {
    job: PropTypes.object.isRequired,
  };

  getStatus() {
    const latestStatus = getLatestStatus(this.props.job);
    return latestStatus.status.message;
  }

  render() {
    const {
      job,
    } = this.props;
    const { shipment_id, _id } = job;
    const origin = job.origin[0];

    let originName = '';
    let originZipCode = '';
    if (origin) {
      originName = origin.name;
      originZipCode = origin.zipcode;
    }

    let destinationName = '';
    let destinationZipCode;
    const destination = job.destination[0];
    if (destination) {
      destinationName = destination.name;
      destinationZipCode = destination.zipcode;
    }

    const shipmentDetailLink = getShipmentDetailUrl(_id);

    return (
      <tr>
        <td><a href={shipmentDetailLink}>{shipment_id}</a></td>
        <td>{originName}({originZipCode})</td>
        <td>{destinationName}({destinationZipCode})</td>
        <td>{this.getStatus()}</td>
      </tr>
    );
  }
}
